import * as React from "react";
const SvgFiRrGlass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.47 1.027A3 3 0 0 0 19.21 0H4.79A3 3 0 0 0 1.82 3.405l2.22 16.27A5.02 5.02 0 0 0 8.991 24h6.016a5.02 5.02 0 0 0 4.954-4.324l2.22-16.271a3 3 0 0 0-.712-2.378m-3.488 18.379A3.01 3.01 0 0 1 15.009 22H8.991a3.01 3.01 0 0 1-2.973-2.595L4.6 9H16a1 1 0 0 0 0-2H4.327L3.8 3.135A1 1 0 0 1 4.791 2H19.21a1 1 0 0 1 .992 1.135z"
    />
  </svg>
);
export default SvgFiRrGlass;
